import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Paper } from '@mui/material';


export default function CustomTabs(props) {

  const renderTabs = () => {

    const tabs = [];

    for (let index in props.names) {
        const title = props.names[index]
        tabs.push(
            <Tab label={title} key={index} value={parseInt(index)}/>
        )
    }

    return tabs;

  }

  return (
    <Paper sx={{display: "flex", justifyContent: "center", p: 1, position: "sticky", top: 0}}>
        <Tabs
          value={props.tabValue}
          onChange={props.handleTabChange}
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          // allowScrollButtonsMobile
          textColor="inherit"
          aria-label="scrollable tabs"
          sx={{ bgcolor: 'background.paper', maxWidth: "fit-content", display: "flex", justifyContent: "center" }}
        >
          {renderTabs()}
        </Tabs>
      </Paper>
  );
}

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      // hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 1, zIndex: 5 }}>
        {children}
      </Box>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};